var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadBr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 15.0002V16.2002C21.5 17.8804 21.5 18.7205 21.173 19.3622C20.8854 19.9267 20.4265 20.3856 19.862 20.6733C19.2202 21.0002 18.3802 21.0002 16.7 21.0002H8.3C6.61984 21.0002 5.77976 21.0002 5.13803 20.6733C4.57354 20.3856 4.1146 19.9267 3.82698 19.3622C3.5 18.7205 3.5 17.8804 3.5 16.2002V15.0002M17.5 10.0002L12.5 15.0002M12.5 15.0002L7.5 10.0002M12.5 15.0002V3.00024",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBr);
export default __webpack_public_path__ + "static/media/download-br.d5309763e6f2b6243becb401103f592c.svg";
export { ForwardRef as ReactComponent };